export default "__VITE_ASSET__5e7928e7__"